module.exports = __webpack_public_path__ + "media/images/logo-a018687d5f9dcf5498d663d7149ac495.svg";